var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.644604 3.89507C0.691086 3.94193 0.746386 3.97913 0.807315 4.00451C0.868245 4.0299 0.933598 4.04297 0.999604 4.04297C1.06561 4.04297 1.13096 4.0299 1.19189 4.00451C1.25282 3.97913 1.30812 3.94193 1.3546 3.89507L3.6446 1.60507C3.69109 1.55821 3.74639 1.52101 3.80732 1.49562C3.86825 1.47024 3.9336 1.45717 3.9996 1.45717C4.06561 1.45717 4.13096 1.47024 4.19189 1.49562C4.25282 1.52101 4.30812 1.55821 4.3546 1.60507L6.6446 3.89507C6.69109 3.94193 6.74639 3.97913 6.80732 4.00452C6.86825 4.0299 6.9336 4.04297 6.9996 4.04297C7.06561 4.04297 7.13096 4.0299 7.19189 4.00452C7.25282 3.97913 7.30812 3.94193 7.3546 3.89507C7.44773 3.80139 7.5 3.67466 7.5 3.54257C7.5 3.41048 7.44773 3.28375 7.3546 3.19007L5.0596 0.895069C4.77835 0.614168 4.39711 0.456389 3.9996 0.456389C3.6021 0.456389 3.22086 0.614168 2.9396 0.895069L0.644604 3.19007C0.551479 3.28375 0.499207 3.41048 0.499207 3.54257C0.499207 3.67466 0.551479 3.80139 0.644604 3.89507Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.2e390f75245661c0b854297ac747c687.svg";
export { ForwardRef as ReactComponent };